import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import {AuthContext} from './AuthContext';

const NotFound = () => {
    const {token} = useContext(AuthContext);
    const returnPath = token ? '/dashboard' : '/';
    const returnLabel = token ? 'Return to dashboard' : 'Return to admin login';

    return (
        <main className="not-found-page container" aria-labelledby="not-found-title">
            <section className="not-found-card card text-center mx-auto">
                <div className="not-found-accent" aria-hidden="true" />
                <div className="card-body">
                    <p className="not-found-brand mb-3">
                        Navipickups <span>Admin</span>
                    </p>
                    <p className="not-found-code mb-3" aria-hidden="true">404</p>
                    <h1 id="not-found-title" className="not-found-title">Page not found</h1>
                    <p className="not-found-message mx-auto mb-4">
                        The page may have moved, or the address may be incorrect.
                        Use the button below to get back on track.
                    </p>
                    <Link className="btn btn-primary not-found-action" to={returnPath}>
                        {returnLabel}
                    </Link>
                </div>
            </section>
        </main>
    );
};

export default NotFound;
